/**
 * Reporting Export Form
 *
 * @version 1.0
 * @author Sabarinath Thulasidharan <sabarinath@paycepaid.com.au>
 */

// import required modules
import React from 'react';
import * as constants from 'includes/constants';
import * as formValidations from 'includes/utils/form';
import * as requestKeys from 'includes/constants/keys/request';
import Button from 'components/shared/Button';
import FormField from 'components/shared/FormField';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Form, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PermissionGuard from 'components/PermissionGuard';
import { REPORTING } from 'includes/constants/permissions';

const ReportExportForm = props => {
    const { t } = useTranslation();
    const loadingExportReport = useSelector(state => state.exports.loadingExport);

    /**
     * Get the localized label
     *
     * @param {string} field Field for which locale is to be generated
     *
     * @returns {string} Generated Locale label
     */
    const getLocaleLabel = field => t(`messages.reporting.export.form.input.label.${field}`);

    return (
        <div className="my-profile-detail settings-edit-form edit-default-settings">
            <header>{props.selectedMenu.name}</header>
            <Form layout="vertical" className="" onSubmit={props.handleSubmit}>
                {props.selectedMenu.showDateRange ? (
                    <Row gutter={16}>
                        <Col span={12}>
                            <Field
                                type="dateRange"
                                name={requestKeys.REPORTING_DATE_RANGE}
                                label={getLocaleLabel(requestKeys.REPORTING_DATE_RANGE)}
                                reduxChange={props.change}
                                component={FormField}
                                validate={[formValidations.required]}
                                required
                            />
                        </Col>
                    </Row>
                ) : (
                    ''
                )}
            </Form>
            <PermissionGuard
                requiredPermission={
                    props.selectedMenu.showDateRange ? REPORTING.PAYMENT_TERMS.EXPORT : REPORTING.DEBT_AGE.EXPORT
                }
            >
                <Form layout="vertical" className="edit-form-update" onSubmit={props.handleSubmit}>
                    <Form.Item className={`update-button ${props.error ? ' has-error default-form-app-error' : ''}`}>
                        {props.error ? <div className="ant-form-explain">{props.error}</div> : ''}
                        <Button
                            htmlType="submit"
                            big
                            filled
                            loading={loadingExportReport}
                            submittingButtonLabel={t(
                                `messages.reporting.export.form.submit.buttonSubmittingLabel.export`
                            )}
                            className="register-btn d-block"
                        >
                            {t(`messages.reporting.export.form.submit.buttonLabel.export`)}
                        </Button>
                    </Form.Item>
                    <div className="clearfix" />
                </Form>
            </PermissionGuard>
        </div>
    );
};

/**
 * Proptypes
 */
ReportExportForm.propTypes = {
    change: PropTypes.func,
    error: PropTypes.string,
    initialValues: PropTypes.object,
    isAdd: PropTypes.bool,
    handleSubmit: PropTypes.func,
    selectedMenu: PropTypes.object,
};

export default reduxForm({
    form: constants.REPORT_EXPORT_FORM,
})(ReportExportForm);
